import { Tool } from "@/types/tools";
import riskBandsBatch from "./risk-bands/batch";
import riskBandsSingle from "./risk-bands/single";
export const defaultOfferingOfTools: Tool[] = [riskBandsSingle, riskBandsBatch];